import { render, staticRenderFns } from "./stockTaking.vue?vue&type=template&id=be52f80a&scoped=true&"
import script from "./stockTaking.vue?vue&type=script&lang=js&"
export * from "./stockTaking.vue?vue&type=script&lang=js&"
import style0 from "./stockTaking.vue?vue&type=style&index=0&id=be52f80a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "be52f80a",
  null
  
)

export default component.exports